export default __webpack_public_path__ + "static/media/pin.3c3b3b1b.svg";